
import React, { useEffect, useState } from "react";
import cancel from "assets/icon/cancel.svg";
import search from "assets/icon/search.svg";
import save from "assets/icon/save.svg";
import { Field, Formik } from "formik";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";
import NDCLISTINPUT from "components/NDCLISTINPUT";
import ErrorBoundary from "components/ErrorBoundary";
import { cellRendererCheck } from "utils/columns";
import ReactStrapTable from "components/reactStrapTable";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import Calendar from "assets/icon/calendar-icon.svg";
import moment from "moment";
import ChargeCodeList from "components/ChargeCodeList";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import useAxios from "hooks/useAxios";
import { cloneDeep } from "lodash";
import { toast } from "react-toastify";
import Loader from "components/Loader";
import ChargeCodeDescriptionSearch from "components/ChargeCodeDescriptionSearch";

let hasDatePopupOpen = false;
let ndcerror = "NDC is a required field";
let gcnerror = "GCN is a required field";
let exchargecodeerror = "Existing Charge Code is a required field"
let chargecoderror = "Charge Code is a required field"
let chargecodedescerror = "Existing Charge Code Description is a required field"
let initialValues = {
    currentPage: 1,
  pageSize: 10,
  order: "desc",
  orderBy: "ModifiedDate",
  filters: [],
  AccumulatorID: 0
};

const AddCrosswalkActiveMapings = ({ orgId, automappingsearch, handelAddMaping, loading, setLoading }) => {
  const [selectedNdc, setSelectedNdc] = useState("");
  //  const [tableData, setTableData] = useState(dummydata);

  const [gcn, setGcn] = useState("");
  const [selectedexchargecode, setSelectedExChargecode] = useState("");
  //const [chargecode, setChargeCode] = useState("");
  //const [chargecodedescription, setChargecodeDescription] = useState("");
  const [error, seterror] = useState(false);
  const [ndctabledata, setNdcTabledata] = useState([]);
  const [ndctotalrecords, setNdcTotalRecords] = useState(0);
  // const [initialValues, setInitialValues] = useState({
  //   ...automappingsearch
  // });
  const API = useAxios()

  useEffect(() => {
    initialValues.AccumulatorID = automappingsearch?.AccumulatorID
  }, [automappingsearch])
  const handleEffectiveDateRaw = (e) => {
    debugger;
    var val = e.target.value;

    var dt = moment(val, "MM/DD/YYYY", true);
    var isValid = dt.isValid();
    // if (isValid == false && startDate !== null) {
    //   // setstartDate(null);
    // }

    if (isValid) {
      // handleStartDate(e.target.value);
    }
  };
  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };
  const handleSubmit = async () => {
    debugger;
    if ((selectedNdc == "" || selectedNdc == null) || (gcn == '' || gcn == null) || (selectedexchargecode == '' || selectedexchargecode == null)) {
      return seterror(true);
    } else {
      setLoading(true);
      let payload = {};
      payload.Chargecode = selectedexchargecode.code;
      payload.ChargeDescription =selectedexchargecode.description;
      payload.GCNSequenceNumber = gcn;
      payload.AccumulatorID = automappingsearch?.AccumulatorID;
      payload.ndc = selectedNdc.code;
      try {
        const { data } = await API.post(`SBTenant/${orgId.tenantID}/CrossWalk/SaveChargeCodeGcn`, payload,
          { hasDefaultURL: true, }
        )
        debugger;
        if (data == true) {
          handelAddMaping(true);
          toast.success('Added Successfully');
          setLoading(false);
          //addCrosswalk();
        }
        else {
          toast.error('ChargeID and GCN relationship already existing.');
          setLoading(false);
        }
      }
      catch {
        setLoading(false);
      }
    }
  };
  const handleCancle = () => {
    handelAddMaping();
  }
  const onSelectndc = async (ndc) => {
    debugger;
    if (ndc) {
      setSelectedNdc(ndc);
      setGcn(ndc.gcn);
      fetchNDCHistoryByGCN(ndc.gcn);
    } else {
      setSelectedNdc("");
      setGcn("");
      setNdcTabledata([]);
      setNdcTotalRecords(0);
    }
  };

  const fetchNDCHistoryByGCN = async (gcn) => {
    debugger;
    let payload = cloneDeep(initialValues);
    payload.AccumulatorID = automappingsearch.AccumulatorID;
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/CrossWalk/GCNHistoryByGCN/${gcn}`,
        payload,
        {
          hasDefaultURL: true,
        }
      );
      if (data?.items?.length > 0) {
        setNdcTabledata(data.items);
        setNdcTotalRecords(data.totalRecords);
      } else {
        setNdcTabledata([]);
        setNdcTotalRecords(0);
      }
      //setLoading(false);
    } catch {
      //setLoading(false);
    }
  };

  const onSearchColumnFilters = async (columnFilters) => {
    debugger;
    const filterObj = cloneDeep(initialValues);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }
    debugger;
    initialValues = cloneDeep(filterObj);
    await fetchNDCHistoryByGCN(gcn);
  };
  const handleFilterCancel = () => {
   initialValues = cloneDeep(automappingsearch);
   fetchNDCHistoryByGCN(gcn);
  };
  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    debugger;
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };
  const onPageChange = (filter, haveColFilter) => {
    debugger;
    if (haveColFilter) {
      const filterObj = cloneDeep(initialValues);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;
      //   setInitialValues({
      //   currentPage: filter.currentPage,
      //   pageSize: filter.pageSize,
      //   ...filter
      // })
      debugger;
      fetchNDCHistoryByGCN(gcn);
    } else {
      debugger;
      initialValues = cloneDeep(filter);
      fetchNDCHistoryByGCN(gcn);

    }
    // updateStates(automappingsearch);
  };

  const onSelectCharge = (charge) => {
    debugger;
    if (charge) {
      setSelectedExChargecode(charge);
      //setChargeCode(charge.code);
     // setChargecodeDescription(charge.description);
    } else {
      setSelectedExChargecode("");
     // setChargeCode("");
      //setChargecodeDescription("");
    }
  }
  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      //   cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 70,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "ndc",
      text: "NDC Code",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.ndc),
    },
    {
      dataField: "DrugName",
      text: "NDC Description",
      sort: false,
      width: 200,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.drugDescription),
    },

  ];

  const handleGCN = (e) => {
    debugger;
    const { value } = e.target;
    setGcn(value);
  }
  const handleChangeCode = (e) => {
    const { value } = e.target;
    setChargeCode(value);
  }
  return (
    <div>
      <Card className="border-0 shadow-top ">
        <CardBody className="section-devider-border">
          <ErrorBoundary>
            <Formik
              initialValues={""}
              onSubmit={handleSubmit}
              // validationSchema={validationSchema}
              // enableReinitialize={true}
              children={(props) => {
                const {
                  isSubmitting,
                  handleSubmit,
                  resetForm,
                  setFieldValue,
                  errors,
                  touched,
                } = props;
                return (
                  <div className="addcrooswalk">
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label style={{}}>Selected by NDC</Label>
                          <NDCLISTINPUT
                            name="ndc"
                            onSelect={onSelectndc}
                            selectedProvider={selectedNdc}
                          />
                          {error && (selectedNdc == "" || selectedNdc == null) ? (
                            <div className="text-danger f-12"
                              style={{ fontWeight: "bold" }}
                            >
                              {ndcerror}
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <Label>GCN</Label>
                        <Input
                          type="text"
                          className="required"
                          value={gcn}
                          // onChange={handleGCN}
                          disabled={true}
                        />
                        {error && (gcn == "" || gcn == null) ? (
                          <div className="text-danger f-12" style={{ fontWeight: "bold" }}>
                            {gcnerror}
                          </div>
                        ) : null}
                      </Col>
                      <Col md={6}>
                        <Label style={{}}>Existing Charge Code</Label>
                        <ChargeCodeList
                          tenantID={orgId.tenantID}
                          onSelect={onSelectCharge}
                          selectedProvider={selectedexchargecode}
                          acid={automappingsearch.AccumulatorID}
                        />
                        {error && (selectedexchargecode == '' || selectedexchargecode == null) ? (
                          <div className="text-danger f-12"
                            style={{ fontWeight: "bold" }}>
                            {exchargecodeerror}
                          </div>
                        ) : null}
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label
                            htmlFor="chargecodedesc" for='chargecodedesc'
                          // className={focusedInput === 'Application' ? 'label-focus' : 'required'}
                          >Existing Charge Code Description</Label>
                          {/* <Input name="chargecodesc"
                            className="required"
                            placeholder="Enter Charge Code Description"
                            value={chargecodedescription}
                            disabled={chargecodedescription ? true : false} />
                          {error && (chargecodedescription == "" || chargecodedescription == null) ? (
                            <div className="text-danger f-12"
                              style={{ fontWeight: "bold" }}>
                              {chargecodedescerror}
                            </div>
                          ) : null} */}
                          <ChargeCodeDescriptionSearch
                          tenantID={orgId.tenantID}
                          onSelect={onSelectCharge}
                          selectedProvider={selectedexchargecode}
                          acid={automappingsearch.AccumulatorID}
                        />
                        {error && (selectedexchargecode == '' || selectedexchargecode == null) ? (
                          <div className="text-danger f-12"
                            style={{ fontWeight: "bold" }}>
                            {chargecodedescerror}
                          </div>
                        ) : null}
                        </FormGroup>

                      </Col>
                    </Row>
                    {/* <Row hidden={true}>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Charge Code</Label>
                          <Input type="text" className="required"
                            value={chargecode}
                            // onChange={handleChangeCode} 
                            disabled={chargecode ? true : false}
                          />
                          {error && (chargecode == "" || chargecode == null) ? (
                            <div className="text-danger f-12"
                              style={{ fontWeight: "bold" }}>
                              {chargecoderror}
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label
                            htmlFor="chargecodedesc" for='chargecodedesc'
                          // className={focusedInput === 'Application' ? 'label-focus' : 'required'}
                          >Charge Code Description</Label>
                          <Input name="chargecodesc"
                            className="required"
                            value={chargecodedescription}
                            disabled={chargecodedescription ? true : false} />
                          {error && (chargecodedescription == "" || chargecodedescription == null) ? (
                            <div className="text-danger f-12"
                              style={{ fontWeight: "bold" }}>
                              {chargecodedescerror}
                            </div>
                          ) : null}
                        </FormGroup>

                      </Col>
                    </Row> */}
                    <div style={{
                      border: "1px solid #D3D3D3",
                      borderRadius: "4px",

                      marginTop: "10px"
                    }}>
                      <div className="p-3">
                        {loading && <Loader opacity={0.01} color="black" />}
                        <div
                          className="table-card scroll-table position-relative border-0 rounded pt-0 mt-2"
                          fixed-height={
                            ndctabledata?.length > 0 ? "fixed-height" : "default"
                          }
                        >
                          <ReactStrapTable
                            id="add-crosswalk-maping"
                            height={550}
                            fixedColumn
                            width={500}
                            hasPagination
                            name={true}
                            // reset={reset}
                            data={ndctabledata}
                            display={true}
                            columns={mainCol}
                            filters={initialValues}
                            totalRecords={ndctotalrecords}
                            pageSize={initialValues.pageSize}
                            currentPage={initialValues.currentPage}
                            onPageChange={onHandlePageChange}
                            onSearchColumnFilters={onSearchColumnFilters}
                            onFilterCancel={handleFilterCancel}
                            // onSearchColumnFilters={}
                            //   hidefilter={true}
                            showtoggle={false}
                          />
                        </div>
                      </div>
                    </div>
                    <Row>
                      <Col
                        md={12}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <div>
                          <div className="mt-3">
                            <Button
                              color="primary"
                              className="search"
                              onClick={handleSubmit}
                            >
                              <span className="right_5">
                                <img src={save} alt="" />
                              </span>{" "}
                              Save
                            </Button>{" "}
                            <Button
                              color="primary"
                              className="reset"
                              onClick={handleCancle}
                            >
                              <span className="right_5">
                                <img src={cancel} alt="" />
                              </span>{" "}
                              Cancel
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                );
              }}
            ></Formik>
          </ErrorBoundary>
        </CardBody>
      </Card>
    </div>
  );
};

export default AddCrosswalkActiveMapings;